var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-config-history"},_vm._l((_vm.list),function(config){return _c('div',{key:config.id,staticClass:"test-config-history__item",on:{"click":() => _vm.changeConfig(config)}},[_vm._v(" "+_vm._s(config.layoutCode)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }